import React from 'react';
import { SmoothPageTransition } from './ui/SmoothPageTransition';

interface LazyPageProps {
  children: React.ReactNode;
}

export const LazyPage: React.FC<LazyPageProps> = ({ children }) => {
  return (
    <SmoothPageTransition>
      {children}
    </SmoothPageTransition>
  );
};
